import { render } from "./App.vue?vue&type=template&id=894b861c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/tailwind_built.css?vue&type=style&index=0&lang=css"
import "./assets/css/mn3.css?vue&type=style&index=1&lang=css"
import "./assets/css/fonts.css?vue&type=style&index=2&lang=css"
import "./assets/css/smooth-label.css?vue&type=style&index=3&lang=css"
import "./assets/css/transitions.css?vue&type=style&index=4&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__